<template>
  <div class="boxes with-slider">
    <!--type slider (desktop)-->
    <slider-select
      v-if="fields[BoxesFields.type].options?.length"
      v-model="form.type"
      class="main-slider"
    >
      <slider-select-option
        v-for="option in fields[BoxesFields.type].options"
        :key="option.value"
        :value="option.value"
        :label="option.title"
        :image-src="uploadsUrl(option?.thumbnail?.data?.attributes.url || '')"
      />
    </slider-select>
    <i-form
      v-scroll-to-invalid
      class="form"
      name="boxes-form"
      @submit="handleSubmit"
    >
      <div class="type">
        <strapi-label
          v-if="labels[BoxesLabels.type]"
          :label="labels[BoxesLabels.type]"
        />
        <div class="form-field-group">
          <!--type field-->
          <zaproo-select
            v-if="fields[BoxesFields.type]"
            v-model="form.type"
            :removable="false"
            searchable
            highlight
            :no-result-label="$t('No results found')"
            no-result-class="text-neutral-900/50 text-center !py-2 !px-4"
            name="type"
            :rules="fieldRules[BoxesFields.type]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[BoxesFields.type]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[BoxesFields.type].options"
              :key="option.value"
              :value="option.value"
              :label="option.title"
            />
          </zaproo-select>
        </div>
        <div class="form-field-group">
          <zaproo-file-input
            v-if="isSelectOtherType && fields[BoxesFields.typeFile]"
            v-model="form.typeFile"
            class="mt-3"
            name="typeFiles"
            :rules="fieldRules[BoxesFields.typeFile]"
            multiple
            :total-size-of-files="INPUT_FILE_TOTAL_SIZE"
            :placeholder="fields[BoxesFields.typeFile].placeholder"
            file-item-classes="h-10"
            remove-button-classes="!p-0"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[BoxesFields.typeFile]"
              />
            </template>
            <template #removeFileText>
              <icons-icon-trash />
              {{ $t("Remove") }}
            </template>
            <template #fileError="{ errors, clear }">
              <div class="mb-2 grid grid-cols-1 gap-2">
                <file-input-error-notification
                  :clear="clear"
                  :errors="errors"
                />
              </div>
            </template>
          </zaproo-file-input>
        </div>
      </div>

      <!--type slider (max to desktop)-->
      <div v-if="fields[BoxesFields.type].options?.length" class="form-slider">
        <slider-select v-model="form.type">
          <slider-select-option
            v-for="option in fields[BoxesFields.type].options"
            :key="option.value"
            :value="option.value"
            :label="option.value"
            :image-src="
              uploadsUrl(option?.thumbnail?.data?.attributes.url || '')
            "
          />
        </slider-select>
      </div>

      <div class="dimensions mt-6">
        <strapi-label
          v-if="labels[BoxesLabels.dimensions]"
          :label="labels[BoxesLabels.dimensions]"
        />
        <div class="form-field-third">
          <zaproo-input
            v-if="fields[BoxesFields.length]"
            v-model="form.length"
            type="number"
            name="length"
            :rules="fieldRules[BoxesFields.length]"
            :placeholder="fields[BoxesFields.length].placeholder"
            :description="fields[BoxesFields.length].description"
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[BoxesFields.length]"
              />
            </template>
          </zaproo-input>

          <zaproo-input
            v-if="fields[BoxesFields.width]"
            v-model="form.width"
            type="number"
            name="width"
            :rules="fieldRules[BoxesFields.width]"
            :placeholder="fields[BoxesFields.width].placeholder"
            :description="fields[BoxesFields.width].description"
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[BoxesFields.width]"
              />
            </template>
          </zaproo-input>

          <zaproo-input
            v-if="fields[BoxesFields.height]"
            v-model="form.height"
            type="number"
            name="height"
            :rules="fieldRules[BoxesFields.height]"
            :placeholder="fields[BoxesFields.height].placeholder"
            :description="fields[BoxesFields.height].description"
            class="form-field"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[BoxesFields.height]"
              />
            </template>
          </zaproo-input>
        </div>
      </div>

      <div class="material mt-6">
        <strapi-label
          v-if="labels[BoxesLabels.material]"
          :label="labels[BoxesLabels.material]"
        />
        <div class="form-field-group">
          <!--material field-->
          <zaproo-select
            v-if="fields[BoxesFields.material]"
            v-model="form.material"
            :removable="false"
            name="material"
            :rules="fieldRules[BoxesFields.material]"
            :placeholder="$t('Select option')"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[BoxesFields.material]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[BoxesFields.material].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>

          <!--mainColor field-->
          <zaproo-select
            v-if="fields[BoxesFields.mainColor]"
            v-model="form.mainColor"
            :removable="false"
            name="mainColor"
            :rules="fieldRules[BoxesFields.mainColor]"
            dropdown-classes="py-2 mt-2"
            class="form-field checkmark"
          >
            <template #label>
              <special-order-form-input-label
                :field="fields[BoxesFields.mainColor]"
              />
            </template>

            <zaproo-select-option
              v-for="option in fields[BoxesFields.mainColor].options"
              :key="option.value"
              :value="option.value"
              >{{ option.title }}</zaproo-select-option
            >
          </zaproo-select>
        </div>
      </div>

      <div class="print mt-6">
        <strapi-label
          v-if="labels[BoxesLabels.print]"
          :label="labels[BoxesLabels.print]"
        />
        <div class="form-field-group">
          <div>
            <!--numberOfPrintColors field-->
            <zaproo-select
              v-if="fields[BoxesFields.numberOfPrintColors]"
              v-model="form.numberOfPrintColors"
              :removable="false"
              :rules="fieldRules[BoxesFields.numberOfPrintColors]"
              dropdown-classes="py-2 mt-2"
              name="numberOfPrintColors"
              class="form-field checkmark"
            >
              <template #label>
                <special-order-form-input-label
                  :field="fields[BoxesFields.numberOfPrintColors]"
                />
              </template>

              <zaproo-select-option
                v-for="option in fields[BoxesFields.numberOfPrintColors]
                  .options"
                :key="option.value"
                :value="option.value"
                >{{ option.title }}</zaproo-select-option
              >
            </zaproo-select>

            <!--designFile field-->
            <zaproo-file-input
              v-if="isPrintDesignFile && fields[BoxesFields.designFile]"
              v-model="form.designFile"
              class="mt-3"
              name="designFiles"
              :rules="fieldRules[BoxesFields.designFile]"
              multiple
              :total-size-of-files="INPUT_FILE_TOTAL_SIZE"
              :placeholder="fields[BoxesFields.designFile].placeholder"
              file-item-classes="h-10"
              remove-button-classes="!p-0"
            >
              <template #label>
                <special-order-form-input-label
                  :field="fields[BoxesFields.designFile]"
                />
              </template>
              <template #removeFileText>
                <icons-icon-trash />
                {{ $t("Remove") }}
              </template>
              <template #fileError="{ errors, clear }">
                <div class="mb-2 grid grid-cols-1 gap-2">
                  <file-input-error-notification
                    :clear="clear"
                    :errors="errors"
                  />
                </div>
              </template>
            </zaproo-file-input>
          </div>
        </div>
      </div>

      <special-order-form-general-contacts-part
        v-model="form"
        class="general-contacts-form"
        :loading="loading"
      >
        <zaproo-input
          v-if="fields[BoxesFields.amountPcs]"
          v-model="form.amountPcs"
          type="number"
          name="amountPcs"
          :rules="fieldRules[BoxesFields.amountPcs]"
          :placeholder="fields[BoxesFields.amountPcs].placeholder"
          :description="fields[BoxesFields.amountPcs].description"
          class="form-field"
        >
          <template #label>
            <special-order-form-input-label
              :field="fields[BoxesFields.amountPcs]"
            />
          </template>
        </zaproo-input>
      </special-order-form-general-contacts-part>
    </i-form>
  </div>
</template>

<script setup lang="ts">
import { Form as IForm, FormActions } from "vee-validate";
import SpecialOrderFormInputLabel from "../SpecialOrderFormInputLabel.vue";
import { BoxesLabels, BoxesFields } from "./types";
import {
  type StrapiField,
  type StrapiLabel as StrapiLabelType,
  type StrapiSpecialOrders,
} from "~/types/strapi";
import { getFieldDefaultModel } from "~/modules/special-orders/helpers";
import StrapiLabel from "~/components/strapi/components/shared/StrapiLabel.vue";
import SliderSelect from "~/modules/special-orders/components/SliderSelect/SliderSelect.vue";
import SliderSelectOption from "~/modules/special-orders/components/SliderSelect/SliderSelectOption.vue";
import FileInputErrorNotification from "~/modules/special-orders/components/SpecialOrderForm/FileInputErrorNotification.vue";
import { INPUT_FILE_TOTAL_SIZE } from "~/modules/special-orders/variables";
import { useFormFieldCleaner } from "~/modules/special-orders/composables/useFormFieldCleaner";

const props = defineProps<{
  specialOrder: StrapiSpecialOrders;
}>();

const { uploadsUrl } = useStrapiExtend();

const { collection: labelCollection } =
  useSpecialOrderUidDictionary<StrapiLabelType>(props.specialOrder.labels);

const { collection: fieldsCollection } =
  useSpecialOrderUidDictionary<StrapiField>(props.specialOrder.fields);

const { sendRequest, loading } = useSpecialOrdersSubmit(props.specialOrder);

const labels = computed(() => labelCollection(BoxesLabels));
const fields = computed(() => fieldsCollection(BoxesFields));
const fieldRules = useSpecialOrderFieldRules<typeof BoxesFields>(fields.value);

const form = ref<ReturnType<typeof resetForm>>(resetForm());

const isPrintDesignFile = computed<boolean>(
  () => form.value.numberOfPrintColors !== "no-print",
);
const isSelectOtherType = computed<boolean>(() => form.value.type === "other");

function resetForm() {
  return {
    type: getFieldDefaultModel(fields.value[BoxesFields.type]),
    length: getFieldDefaultModel(fields.value[BoxesFields.length]),
    width: getFieldDefaultModel(fields.value[BoxesFields.width]),
    height: getFieldDefaultModel(fields.value[BoxesFields.height]),
    material: getFieldDefaultModel(fields.value[BoxesFields.material]),
    mainColor: getFieldDefaultModel(fields.value[BoxesFields.mainColor]),
    numberOfPrintColors: getFieldDefaultModel(
      fields.value[BoxesFields.numberOfPrintColors],
    ),
    amountPcs: getFieldDefaultModel(fields.value[BoxesFields.amountPcs]),
    designFile: [],
    typeFile: [],
    email: "",
    phone: "",
    additionalInfo: "",
  };
}

async function handleSubmit(
  _: Record<string, unknown>,
  { resetForm: reset }: FormActions<Record<string, unknown>>,
) {
  await sendRequest(form.value);
  reset();
  form.value = resetForm();
}

useFormFieldCleaner(
  {
    typeFile: {
      default: () => [],
      ref: isSelectOtherType,
    },
    designFile: {
      default: () => [],
      ref: isPrintDesignFile,
    },
  },
  form,
);
</script>
